/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { MoovError } from "./mooverror.js";

export type PatchTransferValidationErrorData = {
  metadata?: string | undefined;
  foreignID?: string | undefined;
};

export class PatchTransferValidationError extends MoovError {
  metadata?: string | undefined;
  foreignID?: string | undefined;

  /** The original data that was passed to this error instance. */
  data$: PatchTransferValidationErrorData;

  constructor(
    err: PatchTransferValidationErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    if (err.metadata != null) this.metadata = err.metadata;
    if (err.foreignID != null) this.foreignID = err.foreignID;

    this.name = "PatchTransferValidationError";
  }
}

/** @internal */
export const PatchTransferValidationError$inboundSchema: z.ZodType<
  PatchTransferValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  metadata: z.string().optional(),
  foreignID: z.string().optional(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new PatchTransferValidationError(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type PatchTransferValidationError$Outbound = {
  metadata?: string | undefined;
  foreignID?: string | undefined;
};

/** @internal */
export const PatchTransferValidationError$outboundSchema: z.ZodType<
  PatchTransferValidationError$Outbound,
  z.ZodTypeDef,
  PatchTransferValidationError
> = z.instanceof(PatchTransferValidationError)
  .transform(v => v.data$)
  .pipe(z.object({
    metadata: z.string().optional(),
    foreignID: z.string().optional(),
  }));
